import React, { useState } from 'react';
import { Link } from 'react-router-dom';
//import './Agent.css';

const apiUrl = process.env.REACT_APP_API_URL;

const Agent = () => {
  const [userInput, setUserInput] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  console.log("Agent getting user info");
  //useEffect(() => {
  //  // Check if the user is logged in by fetching user info
  //  fetch(apiUrl + "/ai/api/user-info/", {
  //    method: "GET",
  //    credentials: "include", // Include cookies in the request
  //  }, {headers: {
  //    'Content-Type': 'application/json',
  //    'X-CSRFToken': document.cookie.split(';').find(row => row.startsWith('csrftoken=')).split('=')[1],  // CSRF token from the cookie
  //    }
  //  })
  //    .then((response) => {
  //      if (response.ok) {
  //        return response.json();
  //      }
  //      return null;
  //    })
  //    .then((data) => setCurrentUser(data?.username || null))
  //    .catch(() => setCurrentUser(null)); // Treat as anonymous if any error occurs
  //}, []);

  const handleInputChange = (event) => {
    setUserInput(event.target.value);
  };

  const handleLogin = () => {
    const currentUrl = window.location.href;
    window.location.href = apiUrl + `/login?next=${encodeURIComponent(currentUrl)}`;
    };
  const handleLogout = () => {
    fetch(apiUrl + "/logout/", {
      method: "POST",
      credentials: "include",
    })
      .then(() => {
        setCurrentUser(null);
      })
      .catch((error) => console.error("Error logging out:", error));
  };

  const handleSendMessage = async () => {
    if (!userInput.trim()) return; // Prevent sending empty messages
    setChatHistory((prevHistory) => [
      ...prevHistory,
      { sender: 'user', message: userInput },
    ]);

    try {
      const response = await fetch(apiUrl + '/ai/api/agent/chat/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message: userInput }),
      });

      // Check if the response is OK
      if (response.ok) {
        const data = await response.json();
        if (response.message) {
          // Add API response to chat history
          setChatHistory((prevHistory) => [
            ...prevHistory,
            { sender: 'agent', message: data.message }, // Assuming 'reply' is the response field
          ]);
        }
        else {
          console.error('Error:', response.error);
        }
      } else {
        // Handle API errors
        console.error('Error:', response.error);
        setChatHistory((prevHistory) => [
          ...prevHistory,
          { sender: 'agent', message: 'Sorry, something went wrong!' },
        ]);
      }
    } catch (error) {
      console.error('Request failed', error);
      setChatHistory((prevHistory) => [
        ...prevHistory,
        { sender: 'agent', message: 'Sorry, something went wrong!' },
      ]);
    }

    setUserInput('');
  };

  return (
    <div className="agent-page">
      {/* Top Menu */}
      <header className="top-menu">
        <div className="user-info">
          Welcome, <span className="user-name">{currentUser || "Loading..."}</span>
        </div>
        <nav className="menu-links">
          {currentUser ? (
            <button onClick={handleLogout} className="menu-link logout-button">
              Logout
            </button>
          ) : (
            <button onClick={handleLogin} className="menu-link login-button">
              Login
            </button>
          )}
          <Link to="/dashboard" className="menu-link">Dashboard</Link>
        </nav>
      </header>

      {/* Chat Section */}
      <main className="chat-container">
        <div className="content">
          {currentUser ? (
            <p>Enjoy premium features as a logged-in user!</p>
          ) : (
            <p>Log in to access additional features.</p>
          )}
        </div>
        <div className="chat-history">
          {chatHistory.length === 0 ? (
            <p className="no-messages">No messages yet. Start the conversation!</p>
          ) : (
            chatHistory.map((message, index) => (
              <div
                key={index}
                className={`chat-message ${message.sender === 'You' ? 'user-message' : 'agent-message'}`}
              >
                <strong>{message.sender}:</strong> {message.message}
              </div>
            ))
          )}
        </div>

        <div className="chat-input-container">
          <input
            type="text"
            value={userInput}
            onChange={handleInputChange}
            placeholder="Type your message..."
            className="chat-input"
          />
          <button onClick={handleSendMessage} className="chat-send-button">Send</button>
        </div>
      </main>
    </div>
  );
};

export default Agent;
